
import { Component, Inject, OnInit, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { ADMIN_FORM_DATE_FORMATS } from '@default-admin/admin-form/admin-form-date-formats';
import { AppService } from './app.service';

@Component({
    selector: 'app-root',
    template: `
    <router-outlet></router-outlet>`,
    providers: [
        { provide: MAT_DATE_FORMATS, useValue: ADMIN_FORM_DATE_FORMATS },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit {

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private appService: AppService,
  ) {
  }

  ngOnInit(): void {
    if (this.document.location.hostname === 'localhost') {
      this.document.body.classList.add('develop');
      this.appService.environment = 'DEV';
    }
    if (this.document.location.hostname.includes('-t')) {
      this.document.body.classList.add('test');
      this.appService.environment = 'TEST';
    }
  }
}
